import React from "react";
import ArticleBase from "./article-base.tsx";

const Article001 = () => {
  return (
    <ArticleBase title={"so umm, what is a charity?"}>
      <p>Great question Shnoodle – let's jump on in!</p>
    </ArticleBase>
  );
};

export default Article001;
